import { TmcContextService } from './../../../../../../common/tmc-context.service';
import { Component, OnDestroy, OnInit } from '@angular/core';
import { AppFrameContextService, CommonBrowserStorageService } from '@sdbn/common';
import { Subscription } from 'rxjs';

import { Station } from '../../../../../../client/model/station';
import { StationSet } from '../../../../../../client/model/station-set';
import { YardConfiguration } from '../../../../../../client/model/yard-configuration';
import { StationSelection } from '../../../../../../common/model/station-selection.model';
import { SacSelection } from '../../../model/sac-client.model';

@Component({
  selector: 'app-mobile-sac',
  templateUrl: './mobile-sac.component.html',
  styleUrls: ['./mobile-sac.component.scss']
})
export class MobileSACComponent implements OnInit, OnDestroy {

  stationSearchVisible = false;

  selection: SacSelection;

  /* browser storage parameter */
  componentId = 'sac-mobile';
  stationStorageKey = 'current-station';
  stationSetStorageKey = 'current-station-set';

  yardConfiguration: YardConfiguration;
  yardConfigurationSubscription: Subscription;


  constructor(
    private commonBrowserStorageService: CommonBrowserStorageService,
    private appFrameContextService: AppFrameContextService,
    private tmcContextService: TmcContextService,
  ) { }

  ngOnInit(): void {


    this.yardConfigurationSubscription = this.tmcContextService.updated.subscribe(
      yardConfiguration => {
        this.yardConfiguration = yardConfiguration;
        this.readStationFromStorage();
      }
    );

  }

  ngOnDestroy() {
    if (this.yardConfigurationSubscription != null) {
      this.yardConfigurationSubscription.unsubscribe();
    }
  }

  readStationFromStorage() {
    const stationStorageValue = this.commonBrowserStorageService.get(this.appFrameContextService.tenant.value.key, this.componentId, this.stationStorageKey);
    const stationSetStorageValue = this.commonBrowserStorageService.get(this.appFrameContextService.tenant.value.key, this.componentId, this.stationSetStorageKey);

    let currentStation: Station;
    let currentStationSet: StationSet;

    if (stationStorageValue != null) {
      const stationId = parseInt(stationStorageValue);
      const stationSetId = parseInt(stationSetStorageValue);
      if (this.yardConfiguration != null) {
        const stationGroups = this.yardConfiguration.stationGroups;
        for (const group of stationGroups) {
          for (const stationSet of group.stationSets) {
            if (stationSet.id === stationSetId) {
              currentStationSet = stationSet;
              for (const station of stationSet.stations) {
                if (station.id === stationId) {
                  if (currentStation != station) {
                    currentStation = station;
                  }
                  break;
                }
              }
            }
          }
        }
      }
    }
    if (currentStation != null && currentStationSet != null) {
      this.selection = new SacSelection({station: currentStation, stationSet: currentStationSet});
    }
  }

  openStationSelection() {
    this.stationSearchVisible = true;
  }

  closeStationSelection() {
    this.stationSearchVisible = false;
  }

  handleStationSelection(stationSelection: StationSelection) {
    this.selection = new SacSelection(stationSelection);
    this.commonBrowserStorageService.setPersistent(this.appFrameContextService.tenant.value.key, this.componentId, this.stationStorageKey, this.selection.station.id.toString());
    this.commonBrowserStorageService.setPersistent(this.appFrameContextService.tenant.value.key, this.componentId, this.stationSetStorageKey, this.selection.stationSet.id.toString());
  }
}
